import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@ds';
import { AdminFormRow, AdminFormSection } from '@ui';
import { sizes } from '@lp/features/Profile/config';
import { EmployeeFormValues } from '@/types';
import { preventNonNumericKeys } from '@/utils/helpers';
import { ControlledSelect } from '../inputs/ControlledSelect';

type UniformMeasurementsSectionProps = {
  isReadOnly?: boolean;
};

export const UniformMeasurementsSection = memo(({ isReadOnly }: UniformMeasurementsSectionProps) => {
  const { control } = useFormContext<EmployeeFormValues>();

  return (
    <AdminFormSection title="Uniform Measurements" isReadOnly>
      <AdminFormRow title="Scrub size top" isRequired>
        <ControlledSelect name="scrubSizeTop" aria-label="Scrub size top" isDisabled={isReadOnly} items={sizes} />
      </AdminFormRow>
      <AdminFormRow title="Scrub size bottom" isRequired>
        <ControlledSelect name="scrubSizeBottom" aria-label="Scrub size bottom" isDisabled={isReadOnly} items={sizes} />
      </AdminFormRow>
      <AdminFormRow title="Weight" isRequired>
        <Controller
          name="weight"
          control={control}
          render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
            <Input
              placeholder="Weight"
              aria-label="Weight"
              type="number"
              value={`${value}`}
              isDisabled={isReadOnly}
              isInvalid={invalid}
              errorMessage={error?.message}
              inputMode="numeric"
              pattern="[0-9]*"
              onKeyDown={preventNonNumericKeys}
              onChange={(e) => onChange(e.target.value ? Number(e.target.value) : 0)}
              endContent={
                <div className="pointer-events-none flex items-center">
                  <span className="text-s-r text-base-20">lb</span>
                </div>
              }
              {...field}
            />
          )}
        />
      </AdminFormRow>
    </AdminFormSection>
  );
});
